import { Component } from "preact";
import style from "./style";

export default class ProgressBar extends Component {
  render() {
    const percentage = parseFloat(this.props.percentage).toFixed(1);
    return (
      <div className={style.mainWrapper}>
        <div>
          <div className={style.percentageBarWrapper}>
            <div
              className={style.percentageBar}
              style={{ width: `${percentage}%` }}
            />
          </div>
        </div>
        <div>
          <span>{percentage}%</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/tmp_progress_bar/index.js